import React, { memo, useState } from "react";
import clsx from "clsx";
import styles from "./Wheels.module.scss";
import Text from "../../../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../../../../shared-components/css-modules/lexus/atoms/Button";
import type { AtmosphereWheelsType } from "../../../../../../../utils/types/AtmosphereType";
import useAphLbxWheel from "../../../../../../../hooks/lbx/useAphLbxWheel";
import { scrollToTarget } from "../../../../../../../../../../common-deprecated/utils/scrollUtils";
import { CarConfigConfigureSectionsLbx } from "../../../../../../../utils/types/SectionTypesLbx";
import {
    trackViewAtmosphereWheels,
    trackWheelsTyreMoreInfoClose,
    trackWheelsTyreMoreInfoOpen,
} from "../../../../../../../utils/tracking";
import { CarConfigLabel, useCarConfigLabel } from "../../../../../../../utils/labelUtils";
import { useCarConfigSelector } from "../../../../../../../redux/store";
import SidePanel from "../../../../../../../../shared-components/css-modules/lexus/organisms/SidePanel";
import WheelDetails from "../../../../../configure/sections/wheels/WheelDetails";
import Icon from "../../../../../../../../shared-components/css-modules/lexus/atoms/Icon";

export type Props = {
    index: number;
    wheel: AtmosphereWheelsType;
};
const Wheel: React.FC<Props> = (props): JSX.Element => {
    const { index, wheel } = props;
    const showTyreInfo = useCarConfigSelector((state) => !state.carConfigSettings.hideTyreInfo);
    const hasTyres = wheel.tyres.length !== 0;
    const [showInfo, setShowInfo] = useState<boolean>(false);
    const sidePanelTitle = useCarConfigLabel("carConfigTyreInfo");

    const { onClick, isSelectable, isActive } = useAphLbxWheel(wheel);
    return (
        <>
            <article
                className={clsx(styles.wheel, isActive && styles.active)}
                style={{
                    "--or-animation-delay": `${(index + 1) * 100 + 4}`,
                }}
            >
                <Text tag="h4" variant="apheleia-h5">
                    {wheel.name}
                </Text>
                <div>
                    <img role="presentation" src={wheel.asset} alt="" />
                    <div className={styles["wheel-footer"]}>
                        {hasTyres && showTyreInfo && (
                            <Button
                                className={styles.center}
                                variant="apheleia-text"
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    trackWheelsTyreMoreInfoOpen();
                                    setShowInfo(true);
                                }}
                            >
                                <CarConfigLabel label="carConfigWheelMoreInfo" />
                            </Button>
                        )}

                        <Button
                            variant="btn-lbx"
                            disabled={isActive}
                            sizing="full-width"
                            className={styles["wheel-button"]}
                            onClick={
                                isSelectable
                                    ? onClick
                                    : () => {
                                          trackViewAtmosphereWheels();
                                          scrollToTarget(CarConfigConfigureSectionsLbx.AtmosphereGrade);
                                      }
                            }
                        >
                            {isActive ? (
                                <span className={clsx(styles.check, isActive && styles["active-check"])}>
                                    <Icon variant="check" sizing="sm" />
                                </span>
                            ) : (
                                <>
                                    {isSelectable ? (
                                        <CarConfigLabel label="carConfigLbxSelectWheel" />
                                    ) : (
                                        <CarConfigLabel label="carConfigLbxViewAtmosphere" />
                                    )}
                                </>
                            )}
                        </Button>
                    </div>
                </div>
            </article>
            {hasTyres && showTyreInfo && (
                <SidePanel
                    open={showInfo}
                    title={sidePanelTitle}
                    onRequestClose={() => {
                        trackWheelsTyreMoreInfoClose();
                        setShowInfo(false);
                    }}
                >
                    <WheelDetails tyres={wheel.tyres} />
                </SidePanel>
            )}
        </>
    );
};

export default memo(Wheel);
